module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/acuerdo/ver-productos-pedidos/ver-productos-pedidos.component.scss
// module id = ./src/app/acuerdo/ver-productos-pedidos/ver-productos-pedidos.component.scss
// module chunks = main